// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"71d797c1","473":"32a236b1"}[chunkId] + ".chunk.js";
};